import type { TvSummary } from './protocol';
import SummaryLayout from './SummaryLayout';
import { summaryAsLayout } from './summaryLayoutRules';
import './cardChrome.css';

/** Round-summary card mirrored from the phone's summary screens. Display
 * only; the phone dismisses it, or the countdown ring says when it will
 * advance by itself. Every summary draws on the one shared layout
 * (SummaryLayout): a phone that sends its screen as `sections` gets it laid
 * out for 16:9, and a summary without sections (a leaderboard, the Profile
 * hub, an older phone) is converted to sections first (summaryAsLayout,
 * 2026-09-30), so it keeps the overscan margins and the prompt too. */
export default function SummaryCard({ summary }: { summary: TvSummary }) {
  return <SummaryLayout summary={summaryAsLayout(summary)} />;
}
